<template>
  <div>
    <div>
      <dashboard-greeting
      :user-name="current_user.firstName"
      :high-risk-count="0"
      :due-soon-count="0"
      :compliance-rate="0"
    />
      <div class="vx-row" v-can="'view-quick-stats'">
        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
          <statistics-card-line hideChart class="mb-base" icon="GridIcon" icon-right
            :statistic="summary_obj.totalAccounts" statisticTitle="Companies" />
        </div>

        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
          <statistics-card-line hideChart class="mb-base" icon="MapPinIcon" icon-right
            :statistic="summary_obj.totalLocations" statisticTitle="Locations" color="success" />
        </div>

        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
          <statistics-card-line hideChart class="mb-base" icon="HomeIcon" icon-right
            :statistic="summary_obj.totalBuildings" statisticTitle="Buildings" color="success" />
        </div>

        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
          <statistics-card-line hideChart class="mb-base" icon="PhoneIcon" icon-right
            :statistic="summary_obj.totalContacts" statisticTitle="Contacts" color="success" />
        </div>
      </div>

      <div class="vx-row" v-can="'view-quick-stats'">
        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
          <statistics-card-line hideChart class="mb-base" icon="BoxIcon" icon-right
            :statistic="summary_obj.totalPropertyRiskAssessment" statisticTitle="Property Risk Assessments" />
        </div>
        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
          <statistics-card-line hideChart class="mb-base" icon="BoxIcon" icon-right
            :statistic="summary_obj.totalCopeAssessment" statisticTitle="COPE Assessments" />
        </div>
        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
          <statistics-card-line hideChart class="mb-base" icon="BoxIcon" icon-right
            :statistic="summary_obj.totalBrewerySiteInspection" statisticTitle="Brewery Site Inspection" />
        </div>
        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
          <statistics-card-line hideChart class="mb-base" icon="BoxIcon" icon-right
            :statistic="summary_obj.totalHazardInspection" statisticTitle="Hazard Inspection" />
        </div>
      </div>


      <div class="vx-row mb-8" v-can="'view-dashboard'">
        <div class="vx-col w-1/2">
          <vx-card cardBorder noShadow>
            <vue-apex-charts ref="actionByStatusChart" class="w-full" type="bar" height="500"
              :options="lineChartSimple.chartOptions" :series="lineChartSimple.series"></vue-apex-charts>
          </vx-card>
        </div>
        <div class="vx-col w-1/2">
          <vx-card cardBorder noShadow>
            <vue-apex-charts ref="actionByToBeCompleteChart" class="w-full" type="area" height="500"
              :options="lineChartSimple.chartOptions" :series="lineChartSimple.series"></vue-apex-charts>
          </vx-card>
        </div>
      </div>
      <div class="vx-row mb-8" v-can="'view-dashboard'">
        <div class="vx-col w-1/2">
          <vx-card cardBorder noShadow>
            <vue-apex-charts ref="actionByTopCategories" class="w-full" type="bar" height="500"
              :options="lineChartSimple.chartOptions" :series="lineChartSimple.series"></vue-apex-charts>
          </vx-card>
        </div>
      </div>

    </div>
    <!-- <vs-button @click.stop="onClickPdfTest()">
      pdf generate
    </vs-button> -->
  </div>
</template>

<script>
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import analyticsData from './ui-elements/card/analyticsData'
import VueApexCharts from 'vue-apexcharts'
import store from '../store/store.js'
import ChangeTimeDurationDropdown from '@/components/ChangeTimeDurationDropdown.vue'
import { is_live } from "@/constants/config";
import { RepositoryFactory } from '@/repository/RepositoryFactory';
const AdminRepository = RepositoryFactory.get('admin');
import DashboardGreeting from './dashboard/DashboardGreeting.vue'

export default {
  components: {
    StatisticsCardLine,
    VueApexCharts,
    ChangeTimeDurationDropdown,
    DashboardGreeting
  },
  data() {
    return {
      summary_obj: {
        totalAccounts: 0,
        totalBrewerySiteInspection: 0,
        totalBuildings: 0,
        totalContacts: 0,
        totalPropertyRiskAssessment: 0,
        totalLocations: 0,
        totalCopeAssessment: 0,
        totalHazardInspection: 0
      },
      report_data: {},
      is_live: is_live,
      activeItem: 0,
      themeColors: ['#FF9F43', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E'],
      lineChartSimple: {
        series: [],
        chartOptions: {
          chart: {
            height: 350,
            zoom: {
              enabled: false
            }
          },
          colors: ['#2E315D', '#EA5455', '#2E315D', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E'],
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'straight',
            lineCap: 'square'
          },
          title: {
            text: '',
            align: 'left'
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'],
              opacity: 0.5
            },
          },
          xaxis: {
            categories: [],
          },
          yaxis: {
            min: 0,
            forceNiceScale: true,
            labels: {
              formatter: function (val) {
                return val.toFixed(0);
              }
            }
          }
        }
      },
      current_user : {}
    }
  },
  async mounted() {
    this.current_user = store.getters.currentUser
    await this.fetchSummaryCardData()
    await this.fetchReportData()
  },
  methods: {
    async onClickPdfTest() {
      try {
        await AdminRepository.getDashboardPdf()
      } catch (error) {
        console.log(error)
      }
    },
    async fetchSummaryCardData() {
      try {
        const { data } = (await AdminRepository.getDashboardSummary()).data
        this.summary_obj = data
      } catch (error) {

      }
    },
    async fetchReportData() {
      try {
        const { data } = (await AdminRepository.getDashboardReport()).data
        this.report_data = data

        this.$refs.actionByStatusChart.updateOptions({
          series: this.report_data.action.series,
          labels: this.report_data.action.labels,
          title: { text: 'Total actions by status' }
        });

        this.$refs.actionByToBeCompleteChart.updateOptions({
          series: this.report_data.action_data_by_to_be_complete.series,
          labels: this.report_data.action_data_by_to_be_complete.labels,
          title: { text: 'Progress Over Time' }
        });

        this.$refs.actionByTopCategories.updateOptions({
          series: this.report_data.get_trending_issues.series,
          labels: this.report_data.get_trending_issues.labels,
          title: { text: 'Trending Issues ' }
        });
      } catch (error) {

      }
    }
  },
}
</script>


<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user {
    position: relative;

    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }

    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media(max-width: 576px) {

    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}

/*! rtl:end:ignore */
</style>
